<template>
  <div>
    <MemberLayout>
      <iframe class="hierarchy-iframe" :src="iframeURL" ref="iframe"></iframe>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import db from "../../api/db";

// FIXME:
// const hostURL = "https://fordays.ngrok.io";
const hostURL = "https://fordays-backend-official.herokuapp.com";
// 顯示組織圖的Token
const access_token =
  "207a9537bca52a44cbe777626572a2308371826514db1d70767b708f03c449ea";

export default {
  name: "HierachySubScreen",
  components: {
    MemberLayout,
  },
  computed: {
    iframeURL() {
      const vm = this;
      const hierarchyParams = vm.hierarchyParams;
      const searchMonth = vm.searchMonth;
      const queryStartLevel = vm.queryStartLevel;
      const webviewBody = `SEQ=${hierarchyParams.SEQ}&SEARCHMONTH=${searchMonth}&LEVEL=${hierarchyParams.LEVEL}&MAPID=${hierarchyParams.MAPID}&GRPCNT=${hierarchyParams.GRPCNT}&QUERYSTARTLEVEL=${queryStartLevel}&ACCESS_TOKEN=${access_token}`;
      const url = `${hostURL}/member/hierarchyv2-web?${webviewBody}`;
      return url;
    },
  },
  data() {
    return {
      searchMonth: "",
      hostURL: hostURL,
      access_token: access_token,
      user: {},
      hierarchyParams: {},
      queryStartLevel: 1,
      iframeWin: {},
      subSearchSEQ: "",
    };
  },
  mounted() {
    const vm = this;
    window.addEventListener("message", vm.handleIFramePostMessage);
    const session = JSON.parse(window.sessionStorage.getItem("subSearchSEQ"));
    window.sessionStorage.removeItem("subSearchSEQ");
    vm.searchMonth = session.searchMonth;
    const SEQ = session.SEQ;
    fetchData();
    async function fetchData() {
      // 取得目前使用者
      const searchMonth = vm.searchMonth;
      const doc = await db
        // 從JC2map_masterOut集合取得
        .collection("JC2map_masterOut")
        // 一名為SEQ+搜尋營業月份的文件
        .doc(`${SEQ}${searchMonth}`)
        .get();
      if (!doc.exists) {
        vm.hierarchyParams = {};
        return;
      }
      let currentUserJC2Map = doc.data();
      // 取得使用者的等級
      const LEVEL = currentUserJC2Map.LEVEL;
      // 取得使用者的MAPID
      const MAPID = currentUserJC2Map.MAPID;
      // 取得使用者的GRPCNT
      const GRPCNT = currentUserJC2Map.GRPCNT;

      vm.hierarchyParams = {
        SEQ: SEQ,
        LEVEL: LEVEL,
        MAPID: MAPID,
        GRPCNT: GRPCNT,
      };
      setTimeout(() => {
        vm.iframeWin = vm.$refs.iframe.contentWindow;
      }, 2000);
    }
  },
};
</script>
<style scoped>
.hierarchy-iframe {
  width: 100%;
  border: none;
  /* height: calc(100vh - 112px - 41px - 50px - 25px); */
  height: calc(100vh - 150px);
  overflow: scroll;
}
</style>